module.exports = __webpack_public_path__ + "static/media/26UNRWA13.7f3a253f.jpg";